export default 'https://tme.understood.org/assets/collectible.8e16a205.glb'